import React from 'react';
import '../app/App.css';
import Validator from '../../utils/validator';
import axios from 'axios';
import * as config from '../../config/config'
import { RULES } from '../../validates/formCreateValidates';
import { setLocalStore, getLocalStore, convertXxtea, formatDate, formatDateT } from '../helpers/helper';
import GridLoader from "react-spinners/GridLoader";
import {validateData} from '../helpers/validateData'

class FormCreate extends React.Component {
    constructor(props) {
        super(props);

        const queryParams = new URLSearchParams(window.location.search);
        var uuidParams = queryParams.get('uuid');
        var host = queryParams.get('host');
        var membersParam = queryParams.get('members');
        if (membersParam !== null && membersParam !== '') {
            var members = JSON.parse(membersParam);
            if (typeof (members) === 'object') {
                var phoneNum = members[0]['msisdn'];
            } else {
                var phoneNum = null;
            }
        } else {
            var phoneNum = null;
            var members = {};
        }

        if (uuidParams !== null) {
            setLocalStore("uuid", uuidParams);
        } else {
            uuidParams = getLocalStore("uuid");
        }

        if (host !== null) {
            setLocalStore('host', host);
        } else {
            host = getLocalStore('host');
        }

        this.state = {
            jobTitle: '',
            jobDetails: '',
            jobDueDate: formatDateT(new Date(), 1),
            jobDueIndefinite: 0,
            creatorMsisdn: uuidParams,
            host: host,
            listAssignedPerson: '',
            listAssignedGroup: '',
            countMember: '',
            clientType: '',
            listMem: members,
            listMem2: [phoneNum],
            dateNow: formatDateT(new Date(), 0),
            textMember: 'Chọn người',
            errorListMem: 'none',
            errorDueDate: 'none',
            errorsJobTitle: {},
            errorsJobDetails: {},
            errorsJobDueDate: {},
            errorsJobListmem: {},
            loading: false,
        };
        this.handleChooseMember = this.handleChooseMember.bind(this);
        this.handleOpenContact = this.handleOpenContact.bind(this);
        this.handleCompleteTask = this.handleCompleteTask.bind(this);
    }

    componentDidMount() {
        window.chooseMembers = this.handleChooseMember;
        window.openContact = this.handleOpenContact;
        window.completeTask = this.handleCompleteTask;
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        });
    }

    handleChooseMember(data) {
        // var listMembers = [
        //     {
        //         "contactName": "test user 0369945878",
        //         "fullAvatar": "",
        //         "lastChangeAvatar": "",
        //         "msisdn": "0369945878",
        //         "nickName": "test user 0369945878"
        //       },
        //       {
        //         "contactName": "test user 0948222060",
        //         "fullAvatar": "",
        //         "lastChangeAvatar": "",
        //         "msisdn": "0948222060",
        //         "nickName": "test user 0948222060"
        //       }
        // ];
        console.log('Get contact .....');
        console.log(listMembers, 'listmem');
        var listMembers = JSON.parse(data);
        var listChooseMembers = [];
        for (var i = 0; i < listMembers.length; i++) {
            listChooseMembers.push(listMembers[i]['msisdn'])
        }


        this.setState({
            countMember: '(' + listChooseMembers.length + ')',
            listMem: listMembers,
            listMem2: listChooseMembers
        });

        if (listChooseMembers.length === 0) {
            this.setState({
                countMember: '',
                textMember: "Chọn người",
            });
        } else {
            this.setState({
                countMember: '(' + listChooseMembers.length + ')',
                textMember: "Thay đổi",
            });
        }
    };

    handleOpenContact() {

        let listPhones = [];
        let linkContact = '';
        for (var i = 0; i < this.state.listMem.length; i++) {
            if (this.state.listMem[i] == null) {
                console.log('null');
            } else {
                listPhones.push(this.state.listMem[i]);
            }
        }
        console.log(JSON.stringify(listPhones));


        if (listPhones.length > 0) {
            let strPhoneNumber = encodeURIComponent(JSON.stringify(listPhones));
            linkContact = 'vconnect://assignwork?type=selectmembers&ref=createjob&selected=' + strPhoneNumber;
        } else {
            linkContact = 'vconnect://assignwork?type=selectmembers&ref=createjob';
        }

        window.open(linkContact);
        console.log('Open contact ....');
    }

    handleDeleteContact(key) {
        let a = this.state.listMem;
        delete a[key];
        let b = this.state.listMem2;
        delete b[key];

        this.setState({
            countMember: this.state.listMem2.filter(Boolean).length,
            listMem: a,
            listMem2: b
        });


        if (this.state.listMem2.filter(Boolean).length === 0) {
            this.setState({
                countMember: '',
                textMember: "Chọn người",
            });
        } else {
            this.setState({
                countMember: '(' + this.state.listMem2.filter(Boolean).length + ')',
                textMember: "Thay đổi",
            });
        }
    }

    handleCompleteTask = (e) => {
        e.preventDefault();

        //check jobTitle
        let checkTitle = false;
        if (this.state.jobTitle.trim().length === 0) {
            this.setState({
                errorsJobTitle: {error: "Vui lòng điền yêu cầu của công việc."} ,
            });
            checkTitle = false;
        } else {
            if (this.state.jobTitle.trim().length > 50) {
                this.setState({
                    errorsJobTitle: {error: "Trường yêu cầu của công việc không quá 50 ký tự."} ,
                });
            checkTitle = false;
            } else{
                this.setState({
                    errorsJobTitle: {} ,
                });
                checkTitle = true;
            }
        }

        //check jobDetails
        let checkDetail = false
        if (this.state.jobDetails.trim().length > 350) {
            this.setState({
                errorsJobDetails: { error: "Trường nội dung công việc không quá 350 ký tự." },
            });
            checkDetail = false;
        } else {
            this.setState({
                errorsJobDetails: {},
            });
            checkDetail = true ;
        }

        //check duedate
        var jobdate = this.state.jobDueDate;
        var checkTime = false;
        if(jobdate === ''){
            this.setState({
                errorsJobDueDate: { error: "Trường thời hạn của công việc là bắt buộc." },
            });
            checkTime = false;
        }else{
            var due_date = formatDate(new Date(this.state.jobDueDate));
            var current_time = formatDate(new Date());
            if (current_time < due_date) {
                checkTime = true;
                this.setState({
                    errorsJobDueDate: {},
                });
            } else {
                this.setState({
                    errorsJobDueDate: { error: "Thời hạn công việc cần ở tương lai." },
                });
                checkTime = false;
            }
        }    
        
        //check listMem
        let checkListMem = false;
        let strPhone = [];
        for (var i = 0; i < this.state.listMem2.length; i++) {
            if (this.state.listMem2[i] == null) {
                console.log('null');
            } else {
                strPhone.push(this.state.listMem2[i]);
            }
        }

        if(strPhone.length === 0 || strPhone.length > 30){
            this.setState({
                errorsJobListmem: { error: "Số lượng người được giao cần tối thiểu là 1 người và tối đa là 30 người." },
            });
        }else{
            this.setState({
                errorsJobListmem: {},
            });
            checkListMem = true;
        }

        if (checkTitle === false || checkDetail === false || checkTime === false || checkListMem === false ) {
            console.log('errors');
        } else {
            const data = {
                jobTitle: this.state.jobTitle.trim(),
                jobDetails: this.state.jobDetails.trim(),
                jobDueDate: due_date,
                listAssignedPerson: strPhone,
                creatorMsisdn: this.state.creatorMsisdn,
                jobDueIndefinite: this.state.jobDueIndefinite,
            };

            var encrypt_data = convertXxtea(data);
            let timeStamp = new Date().getTime();

            const dataJob = {
                msisdn: this.state.creatorMsisdn,
                host: this.state.host,
                data: encrypt_data,
                clientType: 'web',
                revision: 'a',
                countryCode: 'VN',
                languageCode: 'vi',
                timestamp: timeStamp,
                security: 'a'
            }

            console.log(dataJob);
            this.setState({
                loading: true
            });
            axios({
                method: 'POST',
                url: config.DOMAIN_API_JOB_ASSIGN + 'create_job',
                data: dataJob,
                headers: { 'content-type': 'multipart/form-data' }
            }).then(res => {
                this.setState({
                    loading: false
                });
                console.log(res.data);
                if (res.data.code === 200) {
                    console.log(res.data);
                    window.location.assign('vconnect://assignwork?type=finishedcreating&ref=success&title=' + encodeURIComponent('Tạo công việc thành công'));
                } else {
                    console.log(res.data);
                    window.location.assign('vconnect://assignwork?type=finishedcreating&ref=error&title=' + encodeURIComponent('Tạo công việc không thành công'));
                }
            }).catch(function (result) {
                this.setState({
                    loading: false
                });
                console.log(result.message)
            });
        }

    };



    render() {
        const { errorsJobListmem,errorsJobDueDate,errorsJobDetails,errorsJobTitle, listMem, jobTitle, jobDetails, countMember, errorListMem, jobDueDate, dateNow, errorDueDate, textMember, loading } = this.state;
        return (
            <>
            <GridLoader
                color={'#B80001'}
                loading={loading}
                cssOverride={{
                    display: "block",
                    margin: "auto",
                    position: 'absolute',
                    top: '40vh',
                    left: 'calc(50vw - 28px)',
                }}
                height={35}
                size={15}
                width={4}
                radius={2}
                margin={2}
                aria-label="Loading Spinner"
                data-testid="loader"
            />
                <div className="form-job">
                    <form action="">
                        <div className="job-request form-group">
                            <p className="job-label">Yêu cầu *</p>
                            {errorsJobTitle.error && <div className="validation" style={{ display: 'block' }}>{errorsJobTitle.error}</div>}
                            {/* <input className={`${errors.jobTitle && 'error'}`} type="text" value={jobTitle} name="jobTitle" id="jobTitle" onChange={this.handleChange} placeholder="Tóm lược yêu cầu (dưới 50 ký tự)" /> */}
                            <textarea className={`inputText ${errorsJobTitle.error && 'error'}`} name="jobTitle" value={jobTitle} id="jobTitle" onChange={this.handleChange} cols="30" rows="1" placeholder="Tóm lược yêu cầu (dưới 50 ký tự)"></textarea>
                        </div>
                        <div className="job-detail form-group">
                            <p className="job-label">Nội dung chi tiết</p>
                            {errorsJobDetails.error && <div className="validation" style={{ display: 'block' }}>{errorsJobDetails.error}</div>}
                            <textarea className={`inputText ${errorsJobDetails.error && 'error'}`} name="jobDetails" value={jobDetails} id="jobDetails" onChange={this.handleChange} cols="30" rows="5" placeholder="Cụ thể hóa các yêu cầu đối với công việc này"></textarea>
                        </div>
                        <div className="job-members">
                            <div className="text-head">
                                <p className="job-label">Giao cho * {countMember}</p>
                                <p className="change-member" onClick={this.handleOpenContact}>{textMember}</p>
                            </div>
                            {errorsJobListmem.error && <div className="validation" style={{ display: 'block' }}>{errorsJobListmem.error}</div>}
                            {listMem.length > 0 &&
                                <div className="member-list">
                                    {listMem.map((item, key) => {
                                        return (
                                            <div className="mem" key={key} id={`mem${key}`}>
                                                {/* <img src={item.fullAvatar ? item.fullAvatar : '../../images/icon/defaultUser.png'} alt="avt" /> */}
                                                <img src='../../images/icon/defaultUser.png' alt="avt" />
                                                <img className='btn-close' onClick={() => this.handleDeleteContact(key)} src="./images/icon/x-button.png" alt="" />
                                                <p>{item.contactName}</p>
                                            </div>
                                        )
                                    })}
                                </div>
                            }
                            {/* <p className="btn-add-mem" onClick={this.handleChooseMember}>Chọn người thực hiện công việc</p> */}
                        </div>
                        <div className="due-date form-group">
                            <p className="job-label">Thời hạn *</p>
                            {errorsJobDueDate.error && <div className="validation" style={{ display: 'block' }}>{errorsJobDueDate.error}</div>}
                            {/* <p id='errorDueDate' style={{ display: errorDueDate }} className="validation">Thời hạn công việc cần ở tương lai.</p> */}
                            <input className={`${errorsJobDueDate.error && 'error'}`} type="datetime-local" value={jobDueDate} name="jobDueDate" id="jobDueDate" placeholder='Chọn ngày hết hạn'
                                onChange={this.handleChange} min={dateNow} />
                        </div>
                    </form>
                </div>
                <div className="footer">
                    <div>
                        <button className="btn-complete btn-active" onClick={this.handleCompleteTask}>Hoàn Thành</button>
                    </div>
                </div>
            </>
        )
    }
}


export default FormCreate;
